import { render, staticRenderFns } from "./PaginationPager.vue?vue&type=template&id=02fd71c4&scoped=true"
import script from "./PaginationPager.vue?vue&type=script&lang=js"
export * from "./PaginationPager.vue?vue&type=script&lang=js"
import style0 from "./PaginationPager.vue?vue&type=style&index=0&id=02fd71c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fd71c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrowLeft: require('/opt/atlassian/pipelines/agent/build/components/icon/IconArrowLeft.vue').default,IconArrowRight: require('/opt/atlassian/pipelines/agent/build/components/icon/IconArrowRight.vue').default})
